import PropTypes from 'prop-types';

/**
 * PropTypes for the 3 variants of the ActivityIndicator:
 *   - InlineIndicator
 *   - OverlayIndicator
 *   - FullScreenIndicator
 */
export const activityIndicatorVariantProps = PropTypes.shape({
  /**
   * Indicates the variant style for the ActivityIndicator
   * */
  variant: PropTypes.object,
  /**
   * Size of the dots
   * */
  dotSize: PropTypes.number,
  /**
   * Size of the ActivityIndicator Spinner
   * */
  size: PropTypes.number,
  /**
   * Primary color (Spinner)
   * */
  color: PropTypes.string,
  /**
   * Secondary color (background) of the indicator
   * */
  indicatorBackgroundColor: PropTypes.string,
  /**
   * Thickness of the ActivityIndicator Spinner
   * */
  thickness: PropTypes.number,
  /**
   * Indicates if the ActivityIndicator is static
   * (not animated)
   * */
  isStatic: PropTypes.bool
}).isRequired;
export const activityIndicatorCommonProps = {
  /**
   * Props used by RenderActivityIndicator
   * */
  variantProps: activityIndicatorVariantProps,
  /**
   * Shows or hide the label
   * */
  showLabel: PropTypes.bool,
  /**
   * A visually hidden accessible label describing the action taking place
   */
  label: PropTypes.string,
  /**
   * Position of the label relative to ActivityIndicator
   */
  labelPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  /**
   * Map of flex-direction position for label
   * */
  labelMapping: PropTypes.object.isRequired
};